export default __webpack_public_path__ + "static/media/projectY_small.6a47bc4a.svg";